module.exports = __webpack_public_path__ + "static/media/ErrorWarning.2c930901.svg";